export var toggleSelectedItem = function(index, prevSelected) {
    var isSelected = prevSelected === index;
    return isSelected ? undefined : index;
};
